import { Document } from '../types';

export const mockDocumentsData: Document[] = [
    {
        id: 'doc-001',
        filename: 'Mould_King_Racing_Supercar_15059.pdf',
        fileType: 'pdf',
        uploadDate: '2024-11-12',
        fileSize: '2.4 MB',
        status: 'analyzed',
        setsFound: 1,
        totalBricks: 3890,
        protectedBricks: '4'
    },
    {
        id: 'doc-002',
        filename: 'CaDA_Formula_Racing_Car_C61082.pdf',
        fileType: 'pdf',
        uploadDate: '2024-11-13',
        fileSize: '1.8 MB',
        status: 'analyzed',
        setsFound: 1,
        totalBricks: 1756,
        protectedBricks: '2'
    },
    {
        id: 'doc-003',
        filename: 'Qman_Fire_Station_1412.csv',
        fileType: 'csv',
        uploadDate: '2024-11-11',
        fileSize: '145 KB',
        status: 'analyzed',
        setsFound: 1,
        totalBricks: 1567,
        protectedBricks: '9'
    },
    {
        id: 'doc-004',
        filename: 'Mould_King_Off_Road_Truck_13144.pdf',
        fileType: 'pdf',
        uploadDate: '2024-11-08',
        fileSize: '3.1 MB',
        status: 'analyzed',
        setsFound: 1,
        totalBricks: 2654,
        protectedBricks: '0'
    },
    {
        id: 'doc-005',
        filename: 'Sembo_Sushi_Bar_601124.csv',
        fileType: 'csv',
        uploadDate: '2024-11-09',
        fileSize: '98 KB',
        status: 'analyzed',
        setsFound: 1,
        totalBricks: 1890,
        protectedBricks: '1'
    },
    {
        id: 'doc-006',
        filename: 'Pantasy_Temple_Garden_86214.pdf',
        fileType: 'pdf',
        uploadDate: '2024-11-13',
        fileSize: '2.7 MB',
        status: 'analyzed',
        setsFound: 1,
        totalBricks: 2456,
        protectedBricks: '0'
    },
    {
        id: 'doc-007',
        filename: 'Xingbao_Chinese_Pagoda_01024.pdf',
        fileType: 'pdf',
        uploadDate: '2024-11-08',
        fileSize: '4.2 MB',
        status: 'analyzed',
        setsFound: 1,
        totalBricks: 4567,
        protectedBricks: '5'
    }
];